<template>
  <div>
    <arrorImg bg="white"></arrorImg>
    <navBar title="会员中心" color="#ffffff"></navBar>
    <div class="content_rember">
      <div>
        <div>
          <p>全站书籍免费看</p>
                  <p :class="isVip == 1 ? 'isvip-text' : ''">
                    <span v-if="isVip == 0">开通会员即可畅享受会员特权</span>
                    <span v-else
                      >您已是VIP会员，有效期至 ：{{ EndTime.split(" ")[0] }}</span
                    >
                  </p>
        </div>
        <div style='background-image: url(../../../static/rem_bot_bg.png);'>
          <div class="content-list">
          <span>— VIP会员特权 —</span>
          <div class="scroll-list">
            <div
              class="scroll-item"
              v-for="(item, index) in ListScroll"
              :key="index"
            >
              <img :src="item.url" alt="" />
              <span>{{ item.text }}</span>
            </div>
          </div>
        </div>
        <div class="content-list">
          <span>— VIP会员套餐 —</span>
          <div class="member-list">
            <div
            :style="{marginRight: index%3==2?'0px':'1rem'}"
              v-for="(item, index) in remberList"
              :key="index"
              :class="currenIndex == index ? 'active' : ''"
              @click="chooseList(item, index)"
            >
              <div>
                <span>{{ item.vipName }}</span>
                <img
                  :src="
                    currenIndex == index
                      ? '../../../static/select.png'
                      : '../../../static/no-select.png'
                  "
                  alt=""
                />
              </div>
              <span class="present_price"
                >￥<span style="font-size: 24px">{{
                  item.presentPrice / 100
                }}</span></span
              >
              <span
                class="original_price"
                :class="currenIndex == index ? 'member-before-active' : ''"
                >原价{{ item.originalPrice / 100 }}</span
              >
            </div>
          </div>
        </div>
        <div class="content_vip">
          <!-- 优惠券     -->
          <div v-if="CouponStatus == 0"
            style="width: 100%; margin-bottom: 12px"
        
          >
            <div class="conpon-box" @click="routeChoose">
              <div class="conpon-left">
                <img src="../../../static/conpon_line.png" alt="" />
                <span
                  >满{{ couponItem.fullMoney }}减{{
                    couponItem.reduceMoney
                  }}</span
                >
              </div>
              <div class="conpon-right">
                <span>-{{ couponItem.reduceMoney }}</span>
                <img src="../../../static/light-arrow.png" alt="" />
              </div>
            </div>
          </div>
          <div
            style="width: 100%; margin-bottom: 12px"
            v-if="CouponStatus == 1"
          >
            <div class="conpon-box" @click="routeChoose">
              <div class="conpon-left">
                <img src="../../../static/conpon_line.png" alt="" />
                <span>优惠券</span>
              </div>
              <div class="conpon-right">
                <span>差{{ differenceMoney }}元可使用优惠券</span>
                <img src="../../../static/light-arrow.png" alt="" />
              </div>
            </div>
          </div>
          <div
            style="width: 100%; margin-bottom: 12px"
            v-if="CouponStatus == 2 || CouponStatus == 3"
          >
            <div class="conpon-box" @click="routeChoose">
              <div class="conpon-left">
                <img src="../../../static/conpon_line.png" alt="" />
                <span>优惠券</span>
              </div>
              <div class="conpon-right">
                <span >{{
                  CouponStatus == 2 ? "不使用优惠券" : "无可用优惠券"
                }}</span>
                <img src="../../../static/light-arrow.png" alt="" />
              </div>
            </div>
          </div>
          <div class="notice-tips">
            <span v-for="(item, index) in noticeList" :key="index">{{
              item
            }}</span>
        <span>{{ noticeList.length }}. 主动支付即表示您已阅读并同意
          <span style="color: #fddfa3" @click="routeAgreement">《用户协议》</span>、<span style="color: #fddfa3"
            @click="routeFeed">《隐私政策》</span></span>
            <span>{{ noticeList.length +1}}. 如遇充值问题，请在公众号内点击联系客服菜单获取帮助
        </span>
          </div>
        </div>
        <div class="bottom-code" v-if="CsQrCodeUrl">
      <div>
          <div>
            <img :src="CsQrCodeUrl" alt="">
          </div>
         <p>如遇充值问题，可长按上方二维码</p>
         <p>添加人工客服，立即处理问题</p>
      </div>
    </div>
        </div>
      </div>
   
    </div>

    <div class="pay-btn" @click="goPay">
      <span
        >{{isVip == 0?'立即开通':'立即续费'}}:
        {{ (payItem.money - payItem.couponMoney * 100) / 100 }}元</span
      >
      <span v-if="payItem.couponMoney != 0"
        >(已优惠￥{{ payItem.couponMoney }})</span
      >
    </div>
  </div>
</template>

<script>
import { Toast, MessageBox } from "mint-ui";
import arrorImg from "../../components/arrow-img.vue";
import navBar from "../components/navbar.vue";
export default {
  name: "bookRember",
  components: {
    arrorImg,
    navBar,
  },
  data() {
    return {
      ListScroll: [
        {
          url: "../../../static/Group1.png",
          text: "免费畅读",
        },
        {
          url: "../../../static/Group2.png",
          text: "尊贵标识",
        },
        {
          url: "../../../static/Group3.png",
          text: "专属客服",
        },
        {
          url: "../../../static/Group4.png",
          text: "特权孵化中",
        },
      ],
      remberList: [], //会员列表
      payItem: {
        settingsId: 0,
        money: 0, // 单位:分
        bookId: 0,
        chapterId: 0,
        vipId: 0,
        activityId: 0, //活动编号 ，会员和充值默认为0
        couponMoney: 0,
        couponId: 0,
      },
      EndTime: "",
      isVip: 0,
      currenIndex: 0,
      noticeList: [
        "温馨提示",
        "1.已是会员续费时间将累加",
        "2.会员时长中，1个月=30天，1年=365天",
        "3.未满18周岁的未成年人应在法定监护人同意下进行充值",
      ],
      pageType: "",
      CouponStatus: -1, //0:满减优惠券，1：差多少可使用优惠券 2：不使用优惠券 3：支付提交时优惠券过期如果没有优惠券提示暂无可用优惠券
      receiveCoupons: [],
      couponItem: {},
      differenceMoney: 0, //差多少可使用优惠券
      isReload: false, //是否是从选择优惠券页返回
      isEntranceData: "",
      CsQrCodeUrl:''
    };
  },
  mounted() {
    var that = this;
    window.addEventListener("pageshow", function (e) {
      //如果检测到页面是从“往返缓存”中读取的，刷新页面
      if (e.persisted) {
        that.getUserInfo();
      }
    });
    console.log("hhhhhh");
    // if (!this.$route.meta.isBack) {
    //   if (this.$route.query.isEntranceData) {
    //     this.isEntranceData = this.$route.query.isEntranceData;
    //   }
    //   if (this.$route.query.promotionCode) {
    //     this.promotionCode = this.$route.query.promotionCode;
    //   }
    //   if (this.$route.query.channelRecordId) {
    //     this.channelRecordId = this.$route.query.channelRecordId;
    //   }
    //   if (this.$route.query.messageType) {
    //     this.clickMessId = this.$route.query.clickMessId;
    //     this.messageType = this.$route.query.messageType;
    //   }
    //   this.pageType = this.$route.query.pageType;
    //   var openid = this.$base.getStorage("openid");
    //   var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
    //   if (!openid) {
    //     //静默登录手动登录
    //     this.wechatLogin();
    //   } else if (isWxAuthorized==0 && openid && !this.$store.state.user.isSNS) {
    //     this.$base.setStorage("isSNS", true);
    //     this.$store.state.user.isSNS = true;
    //     this.$commonApi.snsapiUserinfo();
    //     this.getVipRechargeSettings();
    //     this.isVip = this.$base.getStorage("isVip");
    //     this.EndTime = this.$base.getStorage("EndTime");
    //   } else {
    //     this.getVipRechargeSettings();
    //     this.isVip = this.$base.getStorage("isVip");
    //     this.EndTime = this.$base.getStorage("EndTime");
    //   }
    // }
    // this.getUserInfo();
    // this.$commonApi.share();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      this.CouponStatus = -1;
      if (this.$route.query.isEntranceData) {
        this.isEntranceData = this.$route.query.isEntranceData;
      }
      this.pageType = this.$route.query.pageType;
      var openid = this.$base.getStorage("openid");
      var isWxAuthorized = this.$base.getStorage("isWxAuthorized");
      var city = this.$base.getStorage("city");
      if (!openid) {
        //静默登录手动登录
      } else if (
        isWxAuthorized == 0 &&
        city == 1 &&
        openid &&
        !this.$store.state.user.isSNS
      ) {
        this.$base.setStorage("isSNS", true);
        this.$store.state.user.isSNS = true;
        this.$commonApi.snsapiUserinfo();
        this.getVipRechargeSettings();
        this.isVip = this.$base.getStorage("isVip");
        this.EndTime = this.$base.getStorage("EndTime");
      } else {
        this.getVipRechargeSettings();
        this.isVip = this.$base.getStorage("isVip");
        this.EndTime = this.$base.getStorage("EndTime");
      }
    } else {
      this.isVip = this.$base.getStorage("isVip");
      this.EndTime = this.$base.getStorage("EndTime");
      if (this.$base.getStorage("couponStatus")) {
        this.CouponStatus = this.$base.getStorage("couponStatus");
        if (this.CouponStatus != 2) {
          this.payItem.couponId = this.$base.getStorage("couponId");
          this.usersReceiveCoupons(true);
        } else {
          this.payItem.couponId = 0;
          this.payItem.couponMoney = 0;
        }
      } else {
        this.usersReceiveCoupons(false);
      }
    
    }
 

    this.getUserInfo();
    this.$commonApi.share();
  },

  beforeRouteEnter(to, from, next) {
    if (to.name == "bookRember" && from.name == "chooseCoupons") {
      // 当从上个页面chooseCoupons返回当前页面时，不刷新当前页面
      to.meta.isBack = true;
      to.meta.keepAlive = true;
    } else {
      to.meta.isBack = false;
      to.meta.keepAlive = true;
    }
    console.log(from);
    console.log(to);
    next();
  },
  methods: {
    getCsQrCodeUrl(){
      this.$api.getCsQrCodeUrl().then((res) => {
             if(res.status==1){
              this.CsQrCodeUrl=res.data
             }
      })
    },
    getOrderStatus() {
      var isActivity = this.$base.getStorage("isActivity");
      if (isActivity == 1 && this.$base.getStorage("orderNum")) {
        //订单支付成功
        console.log("订单支付成功");
        var params = {
          orderNo: this.$base.getStorage("orderNum"),
          currentPageType: 2,
        };
        this.$api.getOrderStatus(params).then((res) => {
          this.$base.removeStorage("isActivity");
          this.$base.removeStorage("orderNum");
          if (res.status == 1) {
            Toast({
              message: res.message,
            });
          }
        });
      }
    },
    getUserInfo() {
      var params = {
        random: Math.random(),
      };
      this.$api.getUserInfo(params).then((res) => {
        if (res.status == 1) {
          this.$base.setStorage("isVip", res.data.isVip);
          this.$base.setStorage("EndTime", res.data.vipEndDate);
          this.isVip = res.data.isVip;
          this.EndTime = res.data.vipEndDate;
          this.getOrderStatus();
        }
      });
    },
    insertPageAccessData() {
      var pageType = "";
      if (this.pageType == "bookMine") {
        pageType = "我的";
      } else if (this.pageType == "bookRead") {
        pageType = "阅读器";
      } else if (this.pageType == "bookTask") {
        pageType = "任务中心";
      }else if (this.pageType === "bookCity") {
        pageType = "书城";
      } else if (this.pageType === "bookRecharge") {
        pageType = "充值中心";
      }
      var params = {
        pageName: "会员中心",
        pageRemark: "上级页面：" + pageType,
        isEntranceData: this.isEntranceData,
      };
      this.$api.insertPageAccessData(params).then((res) => {});
    },
    usersReceiveCoupons(flag) {
      var params = {
        isRechargePage: 0,
      };
      this.$api.usersReceiveCoupons(params).then((res) => {
        if (res.status === 1) {
          this.receiveCoupons = res.data.couponReturnDTO;
          if (!flag) {
            if (this.CouponStatus == -1 && this.receiveCoupons.length != 0) {
              var id = this.$base.choicelessCoupons(
                this.receiveCoupons,
                this.payItem.money
              );
              var idrgreater = this.$base.choicegreaterCoupons(
                this.receiveCoupons,
                this.payItem.money
              );
              console.log(id);
              if (id != 0) {
                this.payItem.couponId = id;
                this.CouponStatus = 0;
                this.receiveCoupons.forEach((item) => {
                  if (item.id == this.payItem.couponId) {
                    this.couponItem = item;
                    this.payItem.couponMoney = item.reduceMoney;
                  }
                });
              } else if (idrgreater != 0) {
                this.payItem.couponId = 0;
                this.CouponStatus = 1;
                this.payItem.couponMoney = 0;
                this.receiveCoupons.forEach((item) => {
                  if (item.id == idrgreater) {
                    this.differenceMoney =
                      (item.fullMoney * 100 - this.payItem.money) / 100;
                  }
                });
              }
            }
          } else {
            if (this.payItem.couponId) {
              this.receiveCoupons.forEach((item) => {
                if (item.id == this.payItem.couponId) {
                  if (this.payItem.money / 100 >= item.fullMoney) {
                    this.couponItem = item;
                    this.CouponStatus = 0;
                    this.payItem.couponMoney = item.reduceMoney;
                  } else {
                    this.differenceMoney =
                      (item.fullMoney * 100 - this.payItem.money) / 100;
                    this.CouponStatus = 1;
                    this.payItem.couponMoney = 0;
                    this.payItem.couponId = 0;
                  }
                }
              });
            } else {
              var id = this.$base.choicelessCoupons(
                this.receiveCoupons,
                this.payItem.money
              );
              var idrgreater = this.$base.choicegreaterCoupons(
                this.receiveCoupons,
                this.payItem.money
              );
              console.log("id" + id);
              if (id != 0) {
                this.payItem.couponId = id;
                this.CouponStatus = 0;
                this.receiveCoupons.forEach((item) => {
                  if (item.id == this.payItem.couponId) {
                    this.couponItem = item;
                    console.log(this.couponItem);
                    this.payItem.couponMoney = item.reduceMoney;
                  }
                });
              } else if (idrgreater != 0) {
                this.payItem.couponId = 0;
                this.CouponStatus = 1;
                this.payItem.couponMoney = 0;
                this.receiveCoupons.forEach((item) => {
                  if (item.id == idrgreater) {
                    this.differenceMoney =
                      (item.fullMoney * 100 - this.payItem.money) / 100;
                  }
                });
              } else if (flag == 3 && this.receiveCoupons.length == 0) {
                this.CouponStatus = 3;
                this.payItem.couponId = 0;
              }
            }
          }
       
        }
      });
    },
    getVipRechargeSettings() {
      this.$api.getVipRechargeSettings().then((res) => {
        if (res.status == 1) {
          this.remberList = res.data;
          res.data.forEach((item, index) => {
            if (item.isDefault === 0) {
              this.currenIndex = index;
            }
          });
          this.payItem.vipId = res.data[this.currenIndex].id;
          this.payItem.money = res.data[this.currenIndex].presentPrice;
          this.usersReceiveCoupons(false);
          this.insertPageAccessData();
          this.getCsQrCodeUrl();
        }
      });
    },
    chooseList(item, index) {
      this.currenIndex = index;
      this.payItem.vipId = item.id;
      this.payItem.money = item.presentPrice;
      this.payItem.couponId = 0;
      this.payItem.couponMoney = 0;
      this.usersReceiveCoupons(true);
    },
    routeChoose() {
      if (this.CouponStatus != 3) {
        this.$router.push({
          path: "/pages/chooseCoupons/index",
          query: {
            chargeMoney: this.payItem.money,
            couponId: 0,
            pageType: "bookRember",
          },
        });
      }
    },
    routeFeed() {
      this.$router.push({
        path: "/pages/bookFeedback/index",
        query: {
          pageType: "bookRember",
        },
      });
    },
    routeAgreement(){
      this.$router.push({
        path: "/pages/agreement/index",
        query: {
          pageType: "bookRember",
        },
      });
    },
    goPay() {
      this.$api.separateWxpay(this.payItem).then((res) => {
        if (res.status == 1) {
          var url_config = "https://" + window.location.host + "/";
          var data = res.data;
          this.$base.setStorage("isActivity", 1);
          this.$base.setStorage("orderNum", data.orderNo);
          var WXurl = this.$commonApi.PayURL(); //环境
          var URL =
            WXurl +
            "/payIndex.html?pageType=" +
            this.pageType +
            "&type=bookRember&orderNo=" +
            data.orderNo +
            "&officialCode=" +
            data.officialCode +
            "&openid=" +
            this.$base.getStorage("openid") +
            "&configUrl=" +
            url_config;
          window.location.href = URL;
        } else if (res.status == 3) {
          this.payItem.couponId = 0;
          this.payItem.couponMoney = 0;
          this.usersReceiveCoupons(3);
        } else {
          Toast({
            message: res.message,
          });
        }
      });
    },
    getUserCurrency() {
      console.log("tttttt");
      this.$api.getUserCurrency().then((res) => {
        if (res.status == 1) {
          this.$base.setStorage("currency", res.data);
        }
      });
    },
  },
};
</script>
<style scoped>
.conpon-box {
border: 1px solid #84827D;
  border-radius: 8px;
  justify-content: space-between;
  padding: 12px;
  width: 100%;
  display: flex;
  box-sizing: border-box;
}

.conpon-box > div {
  align-items: center;
  display: flex;
}

.conpon-left > img {
  width: 16px;
  height: 16px;
}

.conpon-left > span {
 font-size: 14px;
color: #FAF4E1;
  font-weight: bold;
  margin-left: 8px;
}

.conpon-right > img {
  width: 6px;
  height: 12px;
}

.conpon-right > span {
font-size: 14px;
color: #FFE0A7;
  margin-right: 8px;
}
.content_rember {
  background-color: #000000;
  margin-top: calc(44px + env(safe-area-inset-top));
  position: relative;
}
.content_rember > img {
  width: 100%;
}
.content_rember > div {
  position: absolute;
  left: 0px;
  top: 0px;
  color: #ffe0a7;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  background-size: 100% 100%;
  
}
.content-list > span {
  font-size: 16px;
  color: #fce0b3;
}
.content_rember >div> div:nth-child(1){
  padding-top: 32px;
  background-image: url(../../../static/rem_top_bg.png);
    background-size: 100% 100%;
    position: absolute;
    width: 100%;
    z-index: 9;
    height: 158px;
    box-sizing: border-box;
}
.content_rember >div> div:nth-child(2){
      background-image: url(../../../static/rem_bot_bg.png);
      padding: 0px 20px;
    padding-top:66px;
    position: absolute;
    top: 112px;
    padding-bottom: 50px;
}
.content_rember >div> div > p:nth-child(1) {
  font-size: 40px;
  line-height: 56px;
}
.content_rember >div> div > p:nth-child(2) {
  width: 276px;
  margin:0 auto;
  border: 1px solid #ffe0a7;
  border-radius: 100px;
  margin-top: 10px;
  letter-spacing: 7px;
  font-size: 12px;
  height: 23px;
  line-height: 23px;
}
.content_rember  >div> div  > p.isvip-text {
  letter-spacing: 0px;
}

.scroll-list {
  display: flex;
  margin-bottom: 20px;
  margin-top: 16px;
}
.scroll-item {
  flex: 1;
}
.scroll-list img {
  width: 36px;
  height: 36px;
  display: block;
  margin: 0 auto;
}
.scroll-item span {
  display: block;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  margin-top: 10px;
}
.content_vip > span {
  color: #333333;
  font-weight: bold;
  margin-bottom: 16px;
  display: block;
}
.member-list {
  margin-top: 16px;
  margin-bottom: 16px;
  overflow: hidden;
}
.member-list > div {
  padding: 8px;
  height: 128px;
  box-sizing: border-box;
  text-align: center;
  border: 2px solid #a4a4a4;
  margin-right: 16px;
  width: 96px;
  float: left;
  color: #aaaaaa;
  position: relative;
  margin-bottom: 16px;
  background-color: #232221;
}

.member-list > div > div {
  position: absolute;
  left: -2px;
  top: -2px;
  width: 60px;
}
.member-list > div > div img {
  width: 100%;
}
.member-list > div > div span {
  position: absolute;
  left: 0px;
  top: 0px;
  font-size: 16px;
  color: #232221;
  width: 60px;
  text-align: center;
}
.member-list > div:nth-child(3) {
  margin-right: 0px;
}
.present_price {
  font-size: 25px;
  margin-top: 33px;
  margin-bottom: 4px;
  display: block;
  text-align: center;
}
.original_price {
  display: block;
  text-align: center;
  font-size: 12px;
  text-decoration: line-through;
}
.member-list > div.active {
  border: 2px solid #ffe0a7;
  color: #ffe0a7;
}
.notice-tips {
  font-size: 12px;
  color: #aaa79c;
  text-align: left;
}
.notice-tips > span {
  margin-bottom: 6px;
  display: block;
  line-height: 17px;
}

.pay-btn {
  position: fixed;
  bottom: 0px;
  background-color: #ffe0a7;
  color: #232221;
  width: 100%;
  height: 44px;
  text-align: center;
  line-height: 44px;
  left: 0;
}
.pay-btn > span:nth-child(1) {
  font-size: 16px;
  letter-spacing: 0;
  line-height: 20px;
}
.pay-btn > span:nth-child(2) {
  font-size: 12px;
  letter-spacing: 0;
}
.bottom-code{
  margin-top: 20px;
  /* padding: 20px 16px; */
}
.bottom-code>div{
  width: 100%;
height: 212px;
/* background: #E0F2FF; */
border-radius: 10px;
text-align: center;
padding:20px 0px;
box-sizing: border-box;

}
.bottom-code>div>div{
  width: 128px;
height: 128px;
background: #FDFDFD;
box-shadow: 0px 2px 4px 0px rgba(98,98,98,0.5);
border-radius: 8px;margin:0 auto;
margin-bottom:10px;
}
.bottom-code>div>div img{
  width: 108px;
  height: 108px;
  margin-top: 10px;
}
.bottom-code>div>p{
  font-size: 12px;
color: #868383;
line-height: 17px;
}
</style>



// WEBPACK FOOTER //
// src/view/bookRember/index.vue